// Screen-space data the 3D engine hands to the typography overlay every frame.
// Kept free of three.js so the page can load it without pulling in the 3D bundle.

export interface ScreenPoint {
    x: number
    y: number
    visible: boolean
}

export interface ScreenCircle extends ScreenPoint {
    r: number
}

export interface FilmFrame {
    width: number
    height: number
    portrait: boolean
    spoke: ScreenPoint
    hub: ScreenPoint
    lip: ScreenPoint
    cap: ScreenPoint
    wheel: ScreenCircle
    triptych: ScreenCircle[]
}

const point = (): ScreenPoint => ({ x: 0, y: 0, visible: false })
const circle = (): ScreenCircle => ({ x: 0, y: 0, r: 0, visible: false })

export const createEmptyFrame = (): FilmFrame => ({
    width: 1,
    height: 1,
    portrait: false,
    spoke: point(),
    hub: point(),
    lip: point(),
    cap: point(),
    wheel: circle(),
    triptych: [circle(), circle(), circle()]
})
